import { useCallback } from 'react';
import { gql, useMutation } from '@apollo/client';
import { QUERY_IDEAS_COUNT } from './useIdeasCount';

const DELETE_IDEAS = gql`
  mutation DeleteIdeas($input: IdeasDeletionInput!) {
    ideasRemove(input: $input) {
      ... on IdeasDeletionSuccess {
        success
        message
        ideas {
          id
        }
      }
      ... on CoreWebAppCommonError {
        message
      }
    }
  }
`;

export function useDeleteIdea() {
  const [
    executeDeleteIdea,
    {
      loading: deleteIdeaLoading,
      error: deleteIdeaError,
      data: deleteIdeaData,
    },
  ] = useMutation(DELETE_IDEAS, {
    refetchQueries: [QUERY_IDEAS_COUNT],
  });

  const deleteIdea = useCallback((ideaId) => {
    executeDeleteIdea({
      variables: {
        input: {
          ids: [ideaId],
        },
      },
    });
  }, []);

  return { deleteIdea, deleteIdeaError, deleteIdeaData, deleteIdeaLoading };
}
